// extracted by mini-css-extract-plugin
export var active = "_uy-1";
export var circle = "_uy-0";
export var completed = "_uy-2";
export var connector = "_uy-4";
export var connectorCompleted = "_uy-7";
export var connectorSpacer = "_uy-5";
export var iconStrokeOverride = "_uy-8";
export var labelContainer = "_uy-6";
export var pending = "_uy-3";